import { IconButton } from '@creditornot/cb-button';
import { MoreHorizontal } from '@creditornot/cb-icons';
import { InputAlert } from '@creditornot/cb-input';
import { MenuActionItem } from '@creditornot/cb-menu';
import { LegacyPopover } from '@creditornot/cb-popover';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { OptionValue } from 'apis/restaurant-api/merchant-admin/menu2/types';
import { MenuPermissionsContext } from 'modules/menu/components/MenuPermissionsContext';

type Props = {
  isDefaultChoice: boolean;
  onDelete: () => void;
  onDisable: () => void;
  onEnable: () => void;
  optionChoice: OptionValue;
};

export const OptionChoiceActions = ({ isDefaultChoice, onDelete, onDisable, onEnable, optionChoice }: Props) => {
  const menuPermissions = useContext(MenuPermissionsContext);

  return (
    <LegacyPopover
      showOnHover={false}
      showOnClick
      closeOnClickInside
      placement="bottom-start"
      renderArrow={false}
      content={
        <div>
          {optionChoice.enabled ? (
            <MenuActionItem onClick={onDisable} variant="red">
              <FormattedMessage id="menu-option.option-choice-actions.disable" />
            </MenuActionItem>
          ) : (
            <MenuActionItem onClick={onEnable} variant="black">
              <FormattedMessage id="menu-option.option-choice-actions.enable" />
            </MenuActionItem>
          )}
          {menuPermissions.contentEdit && (
            <LegacyPopover
              disabled={!isDefaultChoice}
              showOnClick={false}
              renderArrow={false}
              content={
                <InputAlert variant="info">
                  <FormattedMessage id="menu-option.option-choice-actions.delete-disabled-default" />
                </InputAlert>
              }
            >
              <MenuActionItem onClick={onDelete} variant="red" disabled={isDefaultChoice}>
                <FormattedMessage id="menu-option.option-choice-actions.delete" />
              </MenuActionItem>
            </LegacyPopover>
          )}
        </div>
      }
    >
      <IconButton variant="blue" size="tiny">
        <MoreHorizontal />
      </IconButton>
    </LegacyPopover>
  );
};
